import Comps from '@owenscorning/react-library';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import NewContractorClaim from './NewContractorClaim';
import CTAButton from '../../../CTAButton';
import RadioButton from '../../../ComponentLibrary/input-elements/oc-radio-button';
import { EMAIL_REGEX } from '../../shared/utils';
import { incrementStep, lookupEmail, setFormData } from '../redux/action';

const TextInput = Comps.Connect.FormElements.Text;

const Step1 = () => {
  const dispatch = useDispatch();
  const { formData, isFetching } = useSelector(state => state);

  const validEmail = new RegExp(EMAIL_REGEX).test(formData.contractorEmail);

  return (
    <>
      {formData.showNewContractorForm && <NewContractorClaim />}
      {!formData.showNewContractorForm && (
        <div>
          <p>To get your claim started, we'll need a little bit of information from you.</p>
          <h4>For this property, are you the...</h4>
          <div
            onChange={event =>
              dispatch(
                setFormData({
                  propertyClaimedBy: event.target.value,
                })
              )
            }
          >
            <div className="radioContainer">
              <RadioButton
                name="propertyClaimedBy"
                value="HOMEOWNER"
                defaultChecked={formData.propertyClaimedBy === 'HOMEOWNER'}
              >
                Property Owner
              </RadioButton>
            </div>
            <div className="radioContainer">
              <RadioButton
                name="propertyClaimedBy"
                value="CONTRACTOR"
                defaultChecked={formData.propertyClaimedBy === 'CONTRACTOR'}
              >
                Contractor
              </RadioButton>
            </div>
          </div>

          <div
            style={{
              display: formData.propertyClaimedBy === 'CONTRACTOR' ? 'block' : 'none',
            }}
          >
            <h4>What’s your email?</h4>
            <div>
              <TextInput
                name="contractorEmail"
                value={formData.contractorEmail || ''}
                htmlAttributes={{
                  placeholder: 'johndoe@gmail.com',
                }}
                onChange={value => dispatch(setFormData({ contractorEmail: value.toLowerCase() }))}
              />
            </div>
          </div>

          <CTAButton
            onClick={
              formData.propertyClaimedBy === 'CONTRACTOR' && formData.contractorEmail
                ? () => {
                    dispatch(lookupEmail());
                  }
                : () => dispatch(incrementStep())
            }
            data-track="form-advance"
            data-track-form-name="Submit Claim"
            data-track-form-step="step 1 - for this property, are you the..."
            element="button"
            text={isFetching ? 'Loading...' : 'Next'}
            type="submit"
            disabled={!(validEmail || formData.propertyClaimedBy === 'HOMEOWNER')}
          />
        </div>
      )}
    </>
  );
};

export default Step1;
